import { address } from "./index.js";
import { organization } from "./index.js";
import { stepExtractOptional, stepExtractArrayToken, stepExtractArrayBegin, skipValue, } from "../../step/parsing/step_deserialization_functions.js";
/* This is generated code, don't modify */
import EntityTypesAP214 from "./entity_types_ap214.gen.js";
///**
// *  */
export class organizational_address extends address {
    get type() {
        return EntityTypesAP214.ORGANIZATIONAL_ADDRESS;
    }
    get organizations() {
        if (this.organizations_ === void 0) {
            let cursor = this.getOffsetCursor(12);
            const buffer = this.buffer;
            const endCursor = buffer.length;
            if (stepExtractOptional(buffer, cursor, endCursor) === null) {
                return [];
            }
            const value = [];
            let signedCursor0 = stepExtractArrayBegin(buffer, cursor, endCursor);
            cursor = Math.abs(signedCursor0);
            while (signedCursor0 >= 0) {
                const value1 = this.extractBufferElement(buffer, cursor, endCursor, organization);
                if (value1 === void 0) {
                    throw new Error("Value in STEP was incorrectly typed");
                }
                cursor = skipValue(buffer, cursor, endCursor);
                value.push(value1);
                signedCursor0 = stepExtractArrayToken(buffer, cursor, endCursor);
                cursor = Math.abs(signedCursor0);
            }
            this.organizations_ = value;
        }
        return this.organizations_;
    }
    get description() {
        if (this.description_ === void 0) {
            this.description_ = this.extractString(13, true);
        }
        return this.description_;
    }
    constructor(localID, internalReference, model) {
        super(localID, internalReference, model);
    }
}
organizational_address.query = [EntityTypesAP214.ORGANIZATIONAL_ADDRESS];
organizational_address.expectedType = EntityTypesAP214.ORGANIZATIONAL_ADDRESS;
